import SearchFormWithRecentSearches from './SearchFormWithRecentSearches.component';

export default SearchFormWithRecentSearches;
